import { Disclosure } from "../core/disclosure";
import { PluginRegistry } from "../core/pluginRegistry";

export class TktDropdown extends Disclosure {
  constructor(element: HTMLElement) {
    super(element, {
      triggerSelector: ".tkt-dropdown__header",
      eventNameRaw: "tktDropdown",
    });
  }

  init(): void {
    this.initDisclosure();
  }

  public expand(): void {
    this.element.setAttribute("aria-expanded", "true");
    this.trigger?.setAttribute("aria-expanded", "true");
    this.dispatchDisclosureEvent("expanded");
  }

  public collapse(): void {
    this.element.setAttribute("aria-expanded", "false");
    this.trigger?.setAttribute("aria-expanded", "false");
    this.dispatchDisclosureEvent("collapsed");
  }
}

PluginRegistry.register("tktDropdown", TktDropdown);
